import { SubmissionPayload, ToolboxTalkPayload } from '../types';

// Point directly to the Worker endpoint, with optional override via localStorage ("api-endpoint").
function getApiBase(): string {
  if (typeof window !== 'undefined') {
    try {
      const override = localStorage.getItem('api-endpoint');
      if (override && override.trim()) {
        return override.replace(/\/$/, '');
      }
    } catch {
      // ignore
    }
  }
  return 'https://function-checks-worker.3bmrn07x.workers.dev';
}

const CHECK_API_ENDPOINT = `${getApiBase()}/api/submit-check`;
const TOOLBOX_API_ENDPOINT = `${getApiBase()}/api/submit-toolbox`;

export async function submitChecklist(payload: SubmissionPayload): Promise<void> {
  const response = await fetch(CHECK_API_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    const detail = await safeParseError(response);
    throw new Error(detail ?? `Request failed (${response.status})`);
  }
}

export async function submitToolboxTalk(payload: ToolboxTalkPayload): Promise<void> {
  const response = await fetch(TOOLBOX_API_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    const detail = await safeParseError(response);
    throw new Error(detail ?? `Request failed (${response.status})`);
  }
}

async function safeParseError(response: Response): Promise<string | undefined> {
  try {
    const data = await response.json();
    return data?.message;
  } catch {
    return undefined;
  }
}
